import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './Footer.scss';

export default function FooterLogo({ logo = {}, link = "" }) {
	return (
		<Link to={link} target="_blank" rel="noopener noreferrer">
			<div className="logoContainer">{logo}</div>
		</Link>
	);
};

FooterLogo.propTypes = {
	logo: PropTypes.object,
	link: PropTypes.string,
};
